import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f7f365f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "employee bg-white relative overflow-y-scroll overflow-x-hidden" }
const _hoisted_2 = { class: "body text-left" }
const _hoisted_3 = { class: "buttons-section sticky top-0 bg-white z-20 pt-8" }
const _hoisted_4 = { class: "button-row pt-6 pb-8" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "my-auto mr-1 ml-2" }, "Chat", -1))
const _hoisted_7 = { class: "user-data bg-white z-20" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "font-bold inline-block" }, "Anagrafica dipendente", -1))
const _hoisted_9 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_10 = { class: "name text-input" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Nome", -1))
const _hoisted_12 = ["value"]
const _hoisted_13 = {
  key: 1,
  class: "animate-pulse bg-primary-100",
  id: "name",
  type: "text",
  placeholder: ""
}
const _hoisted_14 = { class: "surname text-input" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Cognome", -1))
const _hoisted_16 = ["value"]
const _hoisted_17 = {
  key: 1,
  class: "animate-pulse bg-primary-100",
  id: "surname",
  type: "text",
  placeholder: ""
}
const _hoisted_18 = { class: "phone text-input" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "phone" }, "Numero di telefono", -1))
const _hoisted_20 = ["value"]
const _hoisted_21 = {
  key: 1,
  class: "animate-pulse bg-primary-100",
  id: "phone",
  type: "text",
  placeholder: ""
}
const _hoisted_22 = { class: "credentials bg-white" }
const _hoisted_23 = { class: "flex" }
const _hoisted_24 = { class: "flex-auto" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "font-bold inline-block" }, "Credenziali app", -1))
const _hoisted_26 = { class: "flex ml-auto" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mr-3 self-center" }, "Abilita accesso", -1))
const _hoisted_28 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_29 = { class: "email text-input" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Email", -1))
const _hoisted_31 = ["value"]
const _hoisted_32 = {
  key: 1,
  class: "animate-pulse bg-primary-100",
  id: "email",
  type: "text",
  placeholder: ""
}
const _hoisted_33 = { class: "password text-input" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Password", -1))
const _hoisted_35 = {
  key: 1,
  class: "text-xs pt-1 text-primary"
}
const _hoisted_36 = { class: "documents bg-white" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "font-bold" }, "Documenti", -1))
const _hoisted_38 = { class: "buttons" }
const _hoisted_39 = {
  key: 0,
  class: "workingsites bg-white"
}
const _hoisted_40 = {
  key: 1,
  class: "tools bg-white"
}
const _hoisted_41 = {
  key: 2,
  class: "clocking-ins"
}
const _hoisted_42 = {
  key: 3,
  class: "work-reports"
}
const _hoisted_43 = {
  key: 4,
  class: "expenses"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_SecondaryButton = _resolveComponent("SecondaryButton")!
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_UserAssignedWorkingSites = _resolveComponent("UserAssignedWorkingSites")!
  const _component_UserAssignedTools = _resolveComponent("UserAssignedTools")!
  const _component_WorkingSiteClockingInsSection = _resolveComponent("WorkingSiteClockingInsSection")!
  const _component_UserWorkReportsSection = _resolveComponent("UserWorkReportsSection")!
  const _component_UserExpensesSection = _resolveComponent("UserExpensesSection")!
  const _component_EditUserModalDialog = _resolveComponent("EditUserModalDialog")!
  const _component_AddEditDocumentModalDialog = _resolveComponent("AddEditDocumentModalDialog")!
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_SecondaryButton, {
            class: "text-white bg-primary-900 block float-right",
            onClick: _ctx.onChatClick
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_font_awesome_icon, {
                  class: "my-auto icon h-6",
                  icon: ['fas', 'fa-comment-dots']
                }),
                _hoisted_6
              ])
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_PrimaryButton, {
          class: "bg-primary-50 edit-employee-data text-primary inline-block",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editUserDialog()))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Modifica anagrafica")
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            (_ctx.employee != undefined)
              ? (_openBlock(), _createElementBlock("input", {
                  key: 0,
                  id: "name",
                  type: "text",
                  placeholder: "Nome",
                  value: _ctx.employee.name,
                  readonly: ""
                }, null, 8, _hoisted_12))
              : (_openBlock(), _createElementBlock("input", _hoisted_13))
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            (_ctx.employee != undefined)
              ? (_openBlock(), _createElementBlock("input", {
                  key: 0,
                  id: "surname",
                  type: "text",
                  placeholder: "Cognome",
                  value: _ctx.employee.surname,
                  readonly: ""
                }, null, 8, _hoisted_16))
              : (_openBlock(), _createElementBlock("input", _hoisted_17))
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            (_ctx.employee != undefined)
              ? (_openBlock(), _createElementBlock("input", {
                  key: 0,
                  id: "phone",
                  type: "text",
                  placeholder: "Numero di telefono del dipendente",
                  value: _ctx.employee.phone,
                  readonly: ""
                }, null, 8, _hoisted_20))
              : (_openBlock(), _createElementBlock("input", _hoisted_21))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createVNode(_component_PrimaryButton, {
              class: "bg-primary-50 edit-credential-data text-primary inline-block",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editUserDialogIsPresentedUserDialog()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Modifica credenziali")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            (_ctx.employee != undefined)
              ? (_openBlock(), _createBlock(_component_Toggle, {
                  key: 0,
                  class: "inline-block self-center",
                  modelValue: _ctx.employee.isEnabled,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleEnabling($event)))
                }, null, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            (_ctx.employee != undefined)
              ? (_openBlock(), _createElementBlock("input", {
                  key: 0,
                  id: "email",
                  type: "text",
                  placeholder: "email@sultansrl.it",
                  value: _ctx.employee.email,
                  readonly: ""
                }, null, 8, _hoisted_31))
              : (_openBlock(), _createElementBlock("input", _hoisted_32))
          ]),
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            (_ctx.employee != undefined && _ctx.employee.role < _ctx.UserRole.ADMIN)
              ? (_openBlock(), _createElementBlock("input", {
                  key: 0,
                  class: "bg-primary-50 cursor-pointer bg-primary",
                  id: "password-button",
                  type: "button",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editTheUserPassword())),
                  value: "Richiedi modifica password"
                }))
              : _createCommentVNode("", true),
            (_ctx.employee != undefined && _ctx.employee.isPasswordChangeRequested)
              ? (_openBlock(), _createElementBlock("p", _hoisted_35, "La modifica della password è stata richiesta all'utente."))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_36, [
        _hoisted_37,
        _createElementVNode("div", _hoisted_38, [
          _createVNode(_component_PrimaryButton, {
            class: "manage-documents-button outline-button bg-white text-primary-900 inline-block border-primary-900 hover:bg-primary-900 hover:text-white",
            onClick: _ctx.onDocuments
          }, {
            default: _withCtx(() => [
              _createTextVNode("Gestisci documenti")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      (_ctx.employee && _ctx.workingSiteAssignments)
        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
            _createVNode(_component_UserAssignedWorkingSites, {
              modelValue: _ctx.workingSiteAssignments,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.workingSiteAssignments) = $event))
            }, null, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.employee)
        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
            _createVNode(_component_UserAssignedTools, {
              modelValue: _ctx.toolItemsAssignments,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.toolItemsAssignments) = $event)),
              "user-id": _ctx.employee.id
            }, null, 8, ["modelValue", "user-id"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.employee)
        ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
            _createVNode(_component_WorkingSiteClockingInsSection, {
              id: _ctx.employee.id,
              scope: _ctx.ClockingInScope.user,
              user: _ctx.employee
            }, null, 8, ["id", "scope", "user"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.employee)
        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
            _createVNode(_component_UserWorkReportsSection, {
              user: _ctx.employee,
              scope: _ctx.WorkReportScope.user
            }, null, 8, ["user", "scope"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.employee)
        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
            _createVNode(_component_UserExpensesSection, {
              user: _ctx.employee,
              scope: _ctx.UserExpenseScope.user
            }, null, 8, ["user", "scope"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.editUserDialogIsPresented)
      ? (_openBlock(), _createBlock(_component_EditUserModalDialog, {
          key: 0,
          onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.hideEditUserDialog())),
          "model-value": _ctx.employee,
          mode: _ctx.editUserDialogMode
        }, null, 8, ["model-value", "mode"]))
      : _createCommentVNode("", true),
    (_ctx.isShowingAddNewDocument)
      ? (_openBlock(), _createBlock(_component_AddEditDocumentModalDialog, {
          key: 1,
          onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isShowingAddNewDocument = false)),
          tags: {},
          scope: _ctx.DocumentScope.userDocument,
          "user-id": _ctx.employee.id
        }, null, 8, ["scope", "user-id"]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Loader, {
          key: 2,
          message: "Salvataggio..."
        }))
      : _createCommentVNode("", true)
  ]))
}